import { supabase } from "../supabase";
import { getArticleImages } from "./articleImages";
import { getImage, getImageUrl } from "./images";

// get's most recent n articles
export async function getArticles(n) {
    const res  = await supabase.from('article').select().order('article_date', { ascending: false }).limit(10);
    if (res.status !== 200) {
        throw Error('Fetching articles failed');
    }

    return res.data;
}

// get articles with image data
export async function getImageArticles(n) {
    const res = await supabase
        .from('article')
        .select('*, article_image(image_id)')
        .not('article_image', 'is', null)
        .order('article_date', { ascending: false })
        .limit(n || 10);
    
    if (res.error) {
        throw Error('Fetching image articles failed');
    }

    return res.data.filter(article => article.article_image && article.article_image.length > 0);
}

// get articles with text data
export async function getTextArticles(n) {
    const res = await supabase
        .from('article')
        .select('*, text_article_block(text_article_block_id, content, ordinal)')
        .not('text_article_block', 'is', null)
        .order('article_date', { ascending: false })
        .limit(n || 10);
    
    if (res.error) {
        throw Error('Fetching text articles failed');
    }

    return res.data.filter(article => article.text_article_block && article.text_article_block.length > 0);
}

// get single text article by ID with blocks and images
export async function getTextArticle(articleId) {
    const [articleRes, blocksRes, imagesRes] = await Promise.all([
        supabase
            .from('article')
            .select('*')
            .eq('article_id', articleId)
            .single(),
        supabase
            .from('text_article_block')
            .select('*')
            .eq('article_id', articleId)
            .order('ordinal', { ascending: true }),
        supabase
            .from('text_article_image')
            .select('*, image(storage_path, mime_type)')
            .eq('article_id', articleId)
            .order('ordinal', { ascending: true })
    ]);
    
    if (articleRes.error) {
        throw Error('Fetching text article failed');
    }

    // Get public URLs for images
    const imagesWithUrls = await Promise.all(
        (imagesRes.data || []).map(async (imgRecord) => {
            if (imgRecord.image?.storage_path) {
                const { data: urlData } = supabase.storage
                    .from(process.env.REACT_APP_SUPABASE_ARTICLE_BUCKET || 'images')
                    .getPublicUrl(imgRecord.image.storage_path);
                return {
                    ...imgRecord,
                    url: urlData.publicUrl
                };
            }
            return imgRecord;
        })
    );

    return {
        ...articleRes.data,
        text_article_block: blocksRes.data || [],
        text_article_image: imagesWithUrls
    };
}

// returns array of image links
export async function getArticleImageLinks(articleId) {
    const articleImages = await getArticleImages(articleId);

    const list = []
    for (const articleImage of articleImages) {
        const image = await getImage(articleImage.image_id);
        if (!image?.storage_path) continue;
        const imageLink = await getImageUrl(image.storage_path);
        list.push(imageLink);
    }

    return list;
}
